import { render } from "./SsoAccountRegistrationPage.vue?vue&type=template&id=db2bb59e&scoped=true"
import script from "./SsoAccountRegistrationPage.vue?vue&type=script&lang=js"
export * from "./SsoAccountRegistrationPage.vue?vue&type=script&lang=js"

import "./SsoAccountRegistrationPage.vue?vue&type=style&index=0&id=db2bb59e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db2bb59e"]])

export default __exports__